import { useMemo } from 'react';

import appConfig from 'app-config';

import { useDMRoomListQuery } from 'src/hooks/useDirectMessageQuery';

export const useDMNotification = () => {
  const isDMEnabled = appConfig.features.dm.enabled;
  const { data: roomList } = useDMRoomListQuery({ enabled: isDMEnabled });

  const hasUnreadDM = useMemo(
    () =>
      isDMEnabled &&
      (roomList?.some(
        (room) =>
          (room.lastMessageSeqNo ?? 0) > (room.messageSeqNoUserRead ?? 0) &&
          !room.lastMessageSentByMe
      ) ??
        false),
    [isDMEnabled, roomList]
  );

  return hasUnreadDM;
};
